import React, { useMemo } from 'react';
import { arrayOf, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import SectionContainer from '../SectionContainer';
import css from './SectionTabs.module.css';
import { LinkTabNavHorizontal } from '../../../../components';
import { useLocation } from 'react-router-dom';

const SectionTabs = props => {
  const { sectionId, className, rootClassName, appearance, options, sections } = props;
  const { search } = useLocation();
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const params = new URLSearchParams(search);
  const tab = params.get('tab');

  const tabs = useMemo(
    () =>
      sections
        .filter(section => section?.sectionId === 'section-tab')
        .map(section => {
          const { title, callToAction } = section;
          const { href } = callToAction || {};
          const { content } = title || {};
          return {
            text: content || '',
            selected: href === tab,
            buttonClassName: css.tabContent,
            linkProps: {
              name: 'FAQPage',
              to: {
                search: `?tab=${href}`,
              },
            },
          };
        }),
    [tab, sections]
  );

  return (
    <SectionContainer
      id={sectionId}
      contentClassName={classNames(className, css.section)}
      rootClassName={classNames(rootClassName, css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      <LinkTabNavHorizontal tabs={tabs} rootClassName={css.tabs} tabClassName={css.tab} />
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionTabs.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  blocks: [],
  appearance: null,
  options: null,
};

SectionTabs.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  appearance: object,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  blocks: arrayOf(object),
  options: propTypeOption,
};

export default SectionTabs;
